const organizations = {
    organization: 'سازمان',
    page_title: 'سازمان‌ها',
    title: 'سازمان‌ها',
    subtitle: 'سازمان‌ها معمولاً در برنامه‌های SaaS یا چندمستأجری مشابه استفاده می‌شوند و نمایانگر مشتریان شما هستند که تیم‌ها، سازمان‌ها یا شرکت‌های کامل می‌باشند. سازمان‌ها عنصر بنیادی احراز هویت و مجوزدهی B2B هستند.',
    organization_template: 'قالب سازمان',
    organization_id: 'شناسه سازمان',
    members: 'اعضا',
    machine_to_machine: 'برنامه‌های ماشین به ماشین',
    branding: 'برندسازی',
    create_organization: 'ایجاد سازمان',
    setup_organization: 'سازمان خود را راه‌اندازی کنید',
    organization_list_placeholder_title: 'سازمان',
    organization_list_placeholder_text: 'سازمان‌ها اغلب در برنامه‌های SaaS یا چندمستأجری مشابه به‌عنوان بهترین روش استفاده می‌شوند. آن‌ها امکان توسعه برنامه‌هایی را می‌دهند که به مشتریان اجازه ایجاد و مدیریت سازمان‌ها، دعوت اعضا و اختصاص نقش‌ها را می‌دهد.',
    organization_name_placeholder: 'سازمان من',
    organization_description_placeholder: 'توضیح مختصر سازمان',
    organization_permission: 'مجوز سازمان',
    organization_permission_other: 'مجوزهای سازمان',
    create_permission_placeholder: 'مشاهده تاریخچه قرارها',
    organization_role: 'نقش سازمان',
    organization_role_other: 'نقش‌های سازمان',
    organization_role_description: 'نقش سازمان گروهی از مجوزهاست که می‌تواند به کاربران اختصاص یابد. مجوزها باید از مجوزهای ازپیش‌تعریف‌شده سازمان باشند.',
    role: 'نقش',
    search_placeholder: 'جستجو بر اساس نام یا شناسه سازمان',
    search_role_placeholder: 'برای جستجو و انتخاب نقش‌ها تایپ کنید',
    empty_placeholder: '🤔 هنوز هیچ {{entity}}ای راه‌اندازی نکرده‌اید.',
    organization_and_member: 'سازمان و عضو',
    organization_and_member_description: 'سازمان گروهی از کاربران است و می‌تواند نمایانگر تیم‌ها، مشتریان تجاری و شرکت‌های شریک باشد؛ هر کاربر یک «عضو» است. این‌ها می‌توانند موجودیت‌های بنیادی برای مدیریت نیازهای چندمستأجری شما باشند.',
    guide: {
        title: 'با راهنماها شروع کنید',
        subtitle: 'تنظیمات سازمان خود را با راهنماهای ما سریع‌تر راه‌اندازی کنید',
        introduction: {
            title: 'بیایید بفهمیم سازمان در Logto چگونه کار می‌کند',
            section_1: {
                title: 'سازمان گروهی از کاربران (هویت‌ها) است',
            },
            section_2: {
                title: 'قالب سازمان برای کنترل دسترسی برنامه‌های چندمستأجری طراحی شده است',
                description: 'در برنامه‌های SaaS چندمستأجری، چندین سازمان اغلب قالب کنترل دسترسی مشترکی دارند که شامل مجوزها و نقش‌هاست. در Logto ما آن را «قالب سازمان» می‌نامیم.',
                permission_description: 'مجوز سازمان به معنای اجازه دسترسی به یک منبع در زمینه سازمان است.',
                role_description_deprecated: 'نقش سازمان گروهی از مجوزهای سازمان است که می‌تواند به اعضا اختصاص یابد.',
                role_description: 'نقش سازمان گروهی از مجوزهای سازمان یا مجوزهای API است که می‌تواند به اعضا اختصاص یابد.',
            },
            section_3: {
                title: 'آیا می‌توانم مجوزهای API را به نقش‌های سازمان اختصاص دهم؟',
                description: 'بله، می‌توانید مجوزهای API را به نقش‌های سازمان اختصاص دهید. Logto انعطاف لازم برای مدیریت مؤثر نقش‌های سازمان شما را فراهم می‌کند و امکان گنجاندن هم مجوزهای سازمان و هم مجوزهای API در آن نقش‌ها را می‌دهد.',
            },
            section_4: {
                title: 'با تصویر تعامل کنید تا ببینید همه چیز چگونه به هم متصل است',
                description: 'مثالی بزنیم. جان و سارا در سازمان‌های مختلف با نقش‌های متفاوت در زمینه سازمان‌های مختلف هستند. روی ماژول‌های مختلف بروید و ببینید چه اتفاقی می‌افتد.',
            },
        },
        organization_permissions: 'مجوزهای سازمان',
        organization_roles: 'نقش‌های سازمان',
        admin: 'مدیر',
        member: 'عضو',
        guest: 'مهمان',
        role_description: 'نقش «{{role}}» قالب سازمان یکسانی را در سازمان‌های مختلف به اشتراک می‌گذارد.',
        john: 'جان',
        john_tip: 'جان به دو سازمان تعلق دارد با ایمیل «john@email.com» به‌عنوان شناسه یکتا. او مدیر سازمان A و همچنین مهمان سازمان B است.',
        sarah: 'سارا',
        sarah_tip: 'سارا به یک سازمان تعلق دارد با ایمیل «sarah@email.com» به‌عنوان شناسه یکتا. او مدیر سازمان B است.',
    },
};
export default Object.freeze(organizations);
